module.exports = {
  step: { pl: 'Poziom', width: '20%', type: 'text', req: true },
  hourly: { pl: 'Stawka godzinowa', width: '65%', type: 'number', req: true }
}
